export default {
  bookExperiencePanel: '体験予約パネル',
  calendarIcon: 'カレンダーアイコン',
  coverImageForResource: '{{title}}の体験用カバー画像',
  filterBy: '{{filter}}でフィルター',
  filterByDateRange: '日付範囲でフィルター',
  gallery: 'ギャラリー',
  goBack: '前のページに戻る',
  hostUserIcon: 'ホストユーザーのアイコン',
  imageOf: '{{title}}の画像',
  interactiveMapAltText: '選択可能な{{title}}のインタラクティブマップ',
  mediaSlides: 'メディアスライド',
  muteVideo: 'ビデオの音を消す',
  nextPhoto: '次の写真',
  noVideoPlayback: 'ビデオ再生機能なし',
  pauseVideo: 'ビデオを一時停止',
  photoOf: '{{name}}の写真',
  playVideo: 'ビデオを再生',
  previousPhoto: '前の写真',
  moreFiltersAndExperiences: 'その他のフィルターと体験',
  reserveSelectedSlot: '選択したスロットを予約',
  reviewRating: '5段階中 レビュー評価 {{rating}}',
  overallReviewRating: '5段階中 総合レビュー評価 {{rating}}',
  selectCountryCodeForPhoneNumber: '電話番号の国コードを選択',
  selectDate: '日付を選択',
  selectParticipants: '参加者を選択',
  selectSessionTime: 'セッション時間を選択',
  unmuteVideo: 'ビデオの音を戻す',
  viewShoppingCart: 'カートを見る',
  itemsInCart: '{{count}} アイテムがカートにあります',
  zoomIn: '拡大',
  zoomOut: '縮小',
  selectData: '{{data}}を選択',
  reserveName: '{{name}}を予約',
  deleteReservation: '{{experienceTitle}}の予約を削除',
  editParticipantsFor: '{{experienceTitle}}の参加者を編集',
  enterPromoCode: 'プロモーションコードを入力',
  applyPromoCode: 'プロモーションコードを適用',
  increaseAddOnAmount: '選択した{{addOn}}を増やす',
  decreaseAddOnAmount: '選択した{{addOn}}を減らす',
  addOnModal: '{{addOn}}モーダル',
  moreInformationAboutAddOn: '{{addOn}}についての詳細情報',
  decreasePriceTierTickets: '{{priceTier}}チケットを減らす',
  increasePriceTierTickets: '{{priceTier}}チケットを増やす',
  downloadFilename: '{{filename}}をダウンロード',
  viewFullDetailsDescription: '詳細説明を表示',
  viewFullDescription: '詳細説明を表示',
  closeModal: 'モーダルを閉じる',
  hyattBanner: 'ワールド オブ ハイアット会員限定バナー',
  hyattBannerDesc:
    'ワールド オブ ハイアット ロイヤルティプログラムの会員様限定の特典やオファーをお知らせするプロモーションバナー',
  previousSlide: '前のスライド',
  nextSlide: '次のスライド',
  paginationBulletMessage: 'スライドに移動',
  exitFullscreen: 'フルスクリーンモードを終了',
  enterFullscreen: 'フルスクリーンモードを開始',
  videoSlide: 'ビデオスライド',
  imageSlide: '画像スライド',
  of: 'の',
  noDescription: '説明なし',
  mediaGallery: 'カルーセル - メディアギャラリー',
  dateSelector: '日付セレクター',
  nextWeek: '次の週',
  previousWeek: '前の週',
  scheduleAgenda: 'スケジュールアジェンダ',
  scheduleNav: 'スケジュールナビゲーション',
  scheduleViewSelector: 'スケジュール表示セレクター',
  selectedDateAriaLabel: '{{date}}、選択中',
  tapToBookExperience: '{{title}}を予約',
  bookExperienceAriaLabel: '{{title}}を予約',
  joinWaitlistAriaLabel: '{{title}}のキャンセル待ちに参加',
};
